import { IconProps } from "./_types";

const QuestionBubble = ({ size = 24, color = '#072567', ...other }: IconProps) => {
  return (
    <svg
      width={size}
      height={size * (25 / 24)}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M0 3C0 1.35938 1.3125 0 3 0H21C22.6406 0 24 1.35938 24 3V16.5C24 18.1875 22.6406 19.5 21 19.5H14.4844L8.67188 23.8594C8.4375 24.0469 8.15625 24.0469 7.875 23.9531C7.64062 23.8125 7.5 23.5781 7.5 23.25V19.5H3C1.3125 19.5 0 18.1875 0 16.5V3ZM7.92188 5.53125V5.57812C7.73438 6.14062 8.01562 6.79688 8.625 7.03125C9.1875 7.21875 9.84375 6.89062 10.0312 6.32812L10.0781 6.28125C10.125 6.14062 10.2656 6 10.4062 6H13.125C13.5469 6 13.8281 6.32812 13.8281 6.75C13.8281 6.98438 13.7344 7.21875 13.5 7.35938L11.4375 8.53125C11.0625 8.71875 10.8281 9.09375 10.8281 9.51562V10.125C10.8281 10.7812 11.3438 11.25 11.9531 11.25C12.6094 11.25 13.0781 10.7812 13.0781 10.1719L14.625 9.28125C15.5156 8.76562 16.0781 7.78125 16.0781 6.70312C16.0781 5.10938 14.7656 3.75 13.125 3.75H10.4062C9.28125 3.75 8.29688 4.45312 7.92188 5.53125ZM13.5 14.25C13.5 13.4531 12.7969 12.75 12 12.75C11.1562 12.75 10.5 13.4531 10.5 14.25C10.5 15.0938 11.1562 15.75 12 15.75C12.7969 15.75 13.5 15.0938 13.5 14.25Z"
        fill={color}
      />
    </svg>
  );
};

export default QuestionBubble;
